import {
  AbuserVehicleInfo,
  CaseContextType,
  FetchedReportData,
  FilterCriteria,
  ReportStatusType,
  Socials,
  User,
} from "../../types";

export const cases = [
  "abuse",
  "aggression",
  "bullying",
  "child predator",
  "digital abuse",
  "discrimination",
  "drugs",
  "gun violence",
  "harassment",
  "hate crime",
  "human trafficking",
  "insider trading",
  "racism",
  "scam",
  "violence",
  "weapons",
  "other",
];

export const abuseSubCases = [
  "child abuse",
  "rape",
  "sexual abuse",
  "sexual assault",
  "sexual exploitation",
  "sexual harassment at work",
  "school violence",
  "other",
];

export const aggressionSubCases = [
  "aggravated assault",
  "attempt to commit forcible rape",
  "rape by force",
  "other",
];

export const bullyingSubCases = [
  "bullying based on disability",
  "bullying based on sexual orientation",
  "cyber bullying",
  "mobbing",
  "physical bullying",
  "racial, ethnic, or cultural bullying",
  "school bullying",
  "other",
];

export const digitalAbuseSubCases = [
  "digital sexual abuse",
  "intimate content violation",
  "non-consensual media sharing",
  "revenge porn",
  "sexual privacy violation",
  "other",
];

export const discriminationSubCases = [
  "age-based discrimination",
  "disability based",
  "gender-based",
  "political or opinion-based",
  "racial",
  "religious",
  "sexual orientation based",
  "socio-economic",
  "other",
];

export const harassmentSubCases = [
  "child abuse",
  "molestation",
  "online harassment",
  "rape",
  "sexual abuse",
  "sexual assault",
  "sexual harassment at work",
  "sexual exploitation",
  "other",
];

export const hateCrimeSubCases = [
  "gender-based hate crime",
  "gender identity hate crime",
  "political hate crime",
  "racial or ethnic hate crime",
  "religious hate crime",
  "sexual orientation hate crime",
  "socio-economic hate crime",
  "other",
];

export const racismSubCases = [
  "institutional racism",
  "interpersonal racism",
  "structural racism",
  "other",
];

export const violenceSubCases = [
  "domestic violence",
  "gender based violence",
  "hate crime",
  "physical violence",
  "psychological violence",
  "sexual violence",
  "verbal violence",
  "other",
];

export const childPredatorSubCases = [
  "online grooming",
  "child luring",
  "child exploitation",
  "inappropriate content sharing",
  "other",
];

export const humanTraffickingSubCases = [
  "sex trafficking",
  "labor trafficking",
  "domestic servitude",
  "child trafficking",
  "other",
];

export const drugsSubCases = [
  "drug dealing",
  "drug manufacturing",
  "drug distribution",
  "drug use in prohibited areas",
  "other",
];

export const gunViolenceSubCases = [
  "armed assault",
  "gun threat",
  "shooting",
  "illegal possession",
  "other",
];

export const weaponsSubCases = [
  "weapon possession",
  "weapon threat",
  "illegal weapon sales",
  "concealed weapon violation",
  "other",
];

export const scamSubCases = [
  "financial scam",
  "identity theft",
  "phishing",
  "fraud",
  "investment scam",
  "online scam",
  "other",
];

export const insiderTradingSubCases = [
  "securities fraud",
  "stock manipulation",
  "non-public information trading",
  "tipping off",
  "other",
];

export const allSubCases: Record<string, string[]> = {
  abuse: abuseSubCases,
  aggression: aggressionSubCases,
  bullying: bullyingSubCases,
  "child predator": childPredatorSubCases,
  "digital abuse": digitalAbuseSubCases,
  discrimination: discriminationSubCases,
  drugs: drugsSubCases,
  "gun violence": gunViolenceSubCases,
  harassment: harassmentSubCases,
  "hate crime": hateCrimeSubCases,
  "human trafficking": humanTraffickingSubCases,
  "insider trading": insiderTradingSubCases,
  racism: racismSubCases,
  scam: scamSubCases,
  violence: violenceSubCases,
  weapons: weaponsSubCases,
};

export const USStates = {
  alabama: "01",
  alaska: "02",
  arizona: "04",
  arkansas: "05",
  california: "06",
  colorado: "08",
  connecticut: "09",
  delaware: "10",
  "district of columbia": "11",
  florida: "12",
  georgia: "13",
  hawaii: "15",
  idaho: "16",
  illinois: "17",
  indiana: "18",
  iowa: "19",
  kansas: "20",
  kentucky: "21",
  louisiana: "22",
  maine: "23",
  maryland: "24",
  massachusetts: "25",
  michigan: "26",
  minnesota: "27",
  mississippi: "28",
  missouri: "29",
  montana: "30",
  nebraska: "31",
  nevada: "32",
  "new hampshire": "33",
  "new jersey": "34",
  "new mexico": "35",
  "new york": "36",
  "north carolina": "37",
  "north dakota": "38",
  ohio: "39",
  oklahoma: "40",
  oregon: "41",
  pennsylvania: "42",
  "rhode island": "44",
  "south carolina": "45",
  "south dakota": "46",
  tennessee: "47",
  texas: "48",
  utah: "49",
  vermont: "50",
  virginia: "51",
  washington: "53",
  "west virginia": "54",
  wisconsin: "55",
  wyoming: "56",
  "puerto rico": "72",
};

export const genderOptions = [
  { label: "Female", value: "female" },
  { label: "Male", value: "male" },
  { label: "Non-binary", value: "non-binary" },
  { label: "I prefer not to say", value: "withheld" },
  { label: "Unknown", value: "unknown" },
  { label: "Not sure", value: "not sure" },
];

export const ethnicityOptions = [
  { label: "African American or Black", value: "african american or black" },
  { label: "Asian", value: "asian" },
  { label: "Caucasian or White", value: "caucasian or white" },
  { label: "Hispanic or Latino", value: "hispanic or latino" },
  {
    label: "Native American or Alaska Native",
    value: "native american or alaska native",
  },
  {
    label: "Native Hawaiian or Other Pacific Islander",
    value: "native hawaiian or pacific islander",
  },
  {
    label: "Middle Eastern or North African",
    value: "middle eastern or north african",
  },
  { label: "Multiracial or Biracial", value: "multiracial or biracial" },
  { label: "Other", value: "other" },
  { label: "I prefer not to say", value: "withheld" },
  { label: "Unknown", value: "unknown" },
  { label: "Not sure", value: "not sure" },
];

export const referenceAge = [
  { label: "Unknown", value: "unknown" },
  { label: "Under 18", value: "under 18" },
  { label: "18-24 years old", value: "18-24" },
  { label: "25-34 years old", value: "25-34" },
  { label: "35-44 years old", value: "35-44" },
  { label: "45-54 years old", value: "45-54" },
  { label: "55-64 years old", value: "55-64" },
  { label: "65 years old or older", value: "65 or older" },
  { label: "Not sure", value: "not sure" },
];

export const occupationOptions = [
  { label: "Accountant", value: "accountant" },
  { label: "Administrator", value: "administrator" },
  { label: "Assistant", value: "assistant" },
  { label: "Caregiver", value: "caregiver" },
  { label: "Cashier", value: "cashier" },
  { label: "Clerk", value: "clerk" },
  { label: "Cleaner", value: "cleaner" },
  { label: "Construction Worker", value: "construction worker" },
  { label: "Customer Service", value: "customer service" },
  { label: "Designer", value: "designer" },
  { label: "Director", value: "director" },
  { label: "Doctor", value: "doctor" },
  { label: "Driver", value: "driver" },
  { label: "Engineer", value: "engineer" },
  { label: "Farmer", value: "farmer" },
  { label: "Finance Manager", value: "finance manager" },
  { label: "Foster Parent", value: "foster parent" },
  { label: "Girlfriend", value: "girlfriend" },
  { label: "Guard", value: "guard" },
  { label: "Husband", value: "husband" },
  { label: "Lab Technician", value: "lab technician" },
  { label: "Lawyer", value: "lawyer" },
  { label: "Manager", value: "manager" },
  { label: "Mother", value: "mother" },
  { label: "Nurse", value: "nurse" },
  { label: "Office Assistant", value: "office assistant" },
  { label: "Orphanage Caretaker", value: "orphanage caretaker" },
  { label: "Other", value: "other" },
  { label: "Paramedic", value: "paramedic" },
  { label: "Pastor", value: "pastor" },
  { label: "Police Officer", value: "police officer" },
  { label: "Priest", value: "priest" },
  { label: "Professor", value: "professor" },
  { label: "Salesperson", value: "salesperson" },
  { label: "Secretary", value: "secretary" },
  { label: "Security Guard", value: "security guard" },
  { label: "Sister", value: "sister" },
  { label: "Social Worker", value: "social worker" },
  { label: "Step-father", value: "step-father" },
  { label: "Step-mother", value: "step-mother" },
  { label: "Student", value: "student" },
  { label: "Teacher", value: "teacher" },
  { label: "Technician", value: "technician" },
  { label: "Unemployed", value: "unemployed" },
  { label: "Wife", value: "wife" },
  { label: "Worker", value: "worker" },
  { label: "Writer", value: "writer" },
];

export const vehicleColorOptions = [
  { label: "Beige", value: "beige" },
  { label: "Black", value: "black" },
  { label: "Blue", value: "blue" },
  { label: "Bronze", value: "bronze" },
  { label: "Brown", value: "brown" },
  { label: "Burgundy", value: "burgundy" },
  { label: "Champagne", value: "champagne" },
  { label: "Charcoal", value: "charcoal" },
  { label: "Copper", value: "copper" },
  { label: "Coral", value: "coral" },
  { label: "Cyan", value: "cyan" },
  { label: "Gold", value: "gold" },
  { label: "Gray", value: "gray" },
  { label: "Green", value: "green" },
  { label: "Ivory", value: "ivory" },
  { label: "Khaki", value: "khaki" },
  { label: "Lavender", value: "lavender" },
  { label: "Lime", value: "lime" },
  { label: "Magenta", value: "magenta" },
  { label: "Maroon", value: "maroon" },
  { label: "Mint", value: "mint" },
  { label: "Navy", value: "navy" },
  { label: "Orange", value: "orange" },
  { label: "Other", value: "other" },
  { label: "Peach", value: "peach" },
  { label: "Pink", value: "pink" },
  { label: "Purple", value: "purple" },
  { label: "Red", value: "red" },
  { label: "Sand", value: "sand" },
  { label: "Silver", value: "silver" },
  { label: "Teal", value: "teal" },
  { label: "Turquoise", value: "turquoise" },
  { label: "White", value: "white" },
  { label: "Yellow", value: "yellow" },
];

export const vehicleBrandOptions = [
  { label: "Acura", value: "acura" },
  { label: "Alfa Romeo", value: "alfa-romeo" },
  { label: "Aston Martin", value: "aston-martin" },
  { label: "Audi", value: "audi" },
  { label: "Bentley", value: "bentley" },
  { label: "BMW", value: "bmw" },
  { label: "Bugatti", value: "bugatti" },
  { label: "Buick", value: "buick" },
  { label: "Cadillac", value: "cadillac" },
  { label: "Chevrolet", value: "chevrolet" },
  { label: "Chrysler", value: "chrysler" },
  { label: "Dodge", value: "dodge" },
  { label: "Ferrari", value: "ferrari" },
  { label: "Fiat", value: "fiat" },
  { label: "Ford", value: "ford" },
  { label: "Genesis", value: "genesis" },
  { label: "GMC", value: "gmc" },
  { label: "Honda", value: "honda" },
  { label: "Hyundai", value: "hyundai" },
  { label: "Infiniti", value: "infiniti" },
  { label: "Jaguar", value: "jaguar" },
  { label: "Jeep", value: "jeep" },
  { label: "Kia", value: "kia" },
  { label: "Lamborghini", value: "lamborghini" },
  { label: "Land Rover", value: "land-rover" },
  { label: "Lexus", value: "lexus" },
  { label: "Lincoln", value: "lincoln" },
  { label: "Lucid", value: "lucid" },
  { label: "Maserati", value: "maserati" },
  { label: "Mazda", value: "mazda" },
  { label: "McLaren", value: "mclaren" },
  { label: "Mercedes-Benz", value: "mercedes-benz" },
  { label: "Mini", value: "mini" },
  { label: "Mitsubishi", value: "mitsubishi" },
  { label: "Nissan", value: "nissan" },
  { label: "Other", value: "other" },
  { label: "Porsche", value: "porsche" },
  { label: "Ram", value: "ram" },
  { label: "Rivian", value: "rivian" },
  { label: "Rolls-Royce", value: "rolls-royce" },
  { label: "Subaru", value: "subaru" },
  { label: "Tesla", value: "tesla" },
  { label: "Toyota", value: "toyota" },
  { label: "Volkswagen", value: "volkswagen" },
  { label: "Volvo", value: "volvo" },
];

export const socialMediaOptions: {
  label: string;
  value: keyof Socials;
}[] = [
  { label: "Facebook", value: "facebook" },
  { label: "Instagram", value: "instagram" },
  { label: "LinkedIn", value: "linkedin" },
  { label: "Snapchat", value: "snapchat" },
  { label: "Threads", value: "threads" },
  { label: "Tiktok", value: "tiktok" },
  { label: "Twitter (X)", value: "x" },
  { label: "Wechat", value: "wechat" },
];

export const abuserVictimRelationshipOptions = [
  { label: "Acquaintance", value: "acquaintance" },
  {
    label: "Business or establishment customer",
    value: "business or establishment customer",
  },
  { label: "Boss or supervisor", value: "boss or supervisor" },
  { label: "Boyfriend", value: "boyfriend" },
  {
    label: "Caregiver or personal assistant",
    value: "caregiver or personal assistant",
  },
  { label: "Client or service provider", value: "client or service provider" },
  { label: "Colleague", value: "colleague" },
  {
    label: "Doctor or healthcare personnel",
    value: "doctor or healthcare personnel",
  },
  { label: "Driver or passenger", value: "driver or passenger" },
  { label: "Ex-partner or ex-spouse", value: "ex-partner or ex-spouse" },
  { label: "Father", value: "father" },
  { label: "Foster parent", value: "foster parent" },
  { label: "Friend", value: "friend" },
  { label: "Girlfriend", value: "girlfriend" },
  { label: "Husband", value: "husband" },
  { label: "Lab. technician", value: "lab technician" },
  { label: "Landlord or tenant", value: "landlord or tenant" },
  { label: "Manager", value: "manager" },
  {
    label: "Member of an organization or club",
    value: "member of an organization or club",
  },
  { label: "Mother", value: "mother" },
  { label: "Neighbor", value: "neighbor" },
  { label: "None", value: "none" },
  { label: "Nurse", value: "nurse" },
  { label: "Orphanage caretaker", value: "orphanage caretaker" },
  { label: "Other", value: "other" },
  { label: "Other community resident", value: "other community resident" },
  { label: "Priest", value: "priest" },
  {
    label: "Public services customer (transportation, electricity, water, etc)",
    value: "public services customer",
  },
  { label: "Professor", value: "professor" },
  { label: "Schoolmate", value: "schoolmate" },
  { label: "Sister", value: "sister" },
  { label: "Step-father", value: "step-father" },
  { label: "Step-mother", value: "step-mother" },
  { label: "Stranger", value: "stranger" },
  { label: "Student", value: "student" },
  { label: "Subordinate", value: "subordinate" },
  { label: "Wife", value: "wife" },
];

export const abuserAuthorityPositionOptions = [
  { label: "CSI", value: "csi" },
  { label: "Entertainment", value: "entertainment" },
  { label: "FBI", value: "fbi" },
  { label: "Government official", value: "government official" },
  { label: "Influencer", value: "influencer" },
  { label: "Judge", value: "judge" },
  { label: "Journalist", value: "journalist" },
  { label: "Lawyer", value: "lawyer" },
  { label: "Media figure", value: "media figure" },
  { label: "Military", value: "military" },
  { label: "Other", value: "other" },
  { label: "Paramilitary", value: "paramilitary" },
  { label: "Police", value: "police" },
  { label: "Politician", value: "politician" },
  { label: "Public figure", value: "public figure" },
];

export const reportStatusOptions: {
  label: string;
  value: ReportStatusType;
}[] = [
  { label: "Awaiting review", value: "awaiting review" },
  { label: "Under review", value: "under review" },
  { label: "Reviewed", value: "reviewed" },
];

export const reportSortOptions: {
  label: string;
  value: "most recent" | "this week" | "today";
}[] = [
  { label: "Most recent", value: "most recent" },
  { label: "This week", value: "this week" },
  { label: "Today", value: "today" },
];

export const locations = [
  "school",
  "university",
  "place of worship",
  "online",
  "public park",
  "business",
  "social media",
  "other",
] as const;

export type LocationType = (typeof locations)[number];

export const defaultCase = (user?: User | null): CaseContextType => {
  return {
    caseType: undefined,
    subCaseType: undefined,
    incidentDate: null,
    incidentLocation: null,
    detailedIncidentLocation: { state: "", city: "", county: "" },
    incidentDescription: {
      incidentNarration: undefined,
      incidentVoiceNarration: null,
      incidentPhotoEvidence: null,
    },
    hasAbuserInfo: true,
    reporterDetails: {
      role: "",
      gender: undefined,
      age: undefined,
      phone: "",
      email: user?.email || "",
      ethnicity: "",
      socials: {
        instagram: "",
        tiktok: "",
        facebook: "",
        x: "",
        linkedin: "",
        threads: "",
        snapchat: "",
        wechat: "",
      },
    },
    abuserDetails: {
      name: "",
      alias: "",
      gender: undefined,
      refAge: null,
      relation: "",
      occupation: "",
      ethnicity: "",
      socials: {
        instagram: "",
        tiktok: "",
        facebook: "",
        x: "",
        linkedin: "",
        threads: "",
        snapchat: "",
        wechat: "",
      },
      hasSpecialAuthority: false,
      authorityPosition: null,
      phyDescription: "",
      photoDescription: null,
      hasAbuserVehicleInfo: false,
      vehicleInfo: { brand: "", model: "", carColor: "", licensePlate: "" },
    },
    supportServices: {
      NeedAnAttorney: false,
      NeedCounseling: false,
      NeedPrivateInvestigator: false,
    },
  };
};

export const sampleReportPreview: FetchedReportData = {
  reportId: "337965",
  caseName: "aggression",
  caseType: "aggravated assault",
  incidentDescription: {
    date: "2024-12-24",
    location: "online",
    digitalcaseLinks: ["https://google.com", "https://dumostech.com"],
    detailedLocation: {
      state: "alaska",
      county: "anchorage municipality",
      city: "anchorage census subarea",
    },
    description: "Snuck in my house and beat me up",
    incidentPhotoEvidence: [
      "https://unspokenn-media.s3.us-east-1.amazonaws.com/incident-photos/1742037532526-0-jude.jpeg",
      "https://unspokenn-media.s3.us-east-1.amazonaws.com/incident-photos/1742037532526-0-jude.jpeg",
    ],
    incidentVoiceNarration: [
      "https://unspokenn-media.s3.us-east-1.amazonaws.com/voice-narration/1742037532979-0-voice-recording.webm",
    ],
  },
  reporterDetails: {
    role: "victim",
    gender: "male",
    age: "under 18",
    phone: "+12345678902",
    email: "pikarestiv@gmail.com",
    socials: {
      instagram: "dudutek",
      tiktok: "dutk",
      facebook: "",
      x: "",
      linkedin: "",
      threads: "",
      snapchat: "",
      wechat: "",
    },
    ethnicity: "caucasian or white",
  },
  hasAbuserInfo: true,
  abuserDetails: {
    name: "Mr. Nicholas",
    nickname: "Santa Clause",
    gender: "male",
    refAge: "45-54",
    vehicleInfo: null,
    relationToVictim: "Gifter",
    hasSpecialAuthority: true,
    specialAuthorityPosition: "He's santa fgs",
    photoDescription: undefined,
    phyDescription: "Red and white clothings",
    hasAbuserVehicleInfo: false,
    occupation: "Santa",
    socials: {
      instagram: "",
      tiktok: "",
      facebook: "",
      x: "",
      linkedin: "",
      threads: "",
      snapchat: "",
      wechat: "",
    },
    ethnicity: "caucasian or white",
    abuserPhotoDescription: [
      "https://unspokenn-media.s3.us-east-1.amazonaws.com/abuser-photos/1742037533128-0-download.jpeg",
      "https://unspokenn-media.s3.us-east-1.amazonaws.com/abuser-photos/1742037533128-0-download.jpeg",
      "https://unspokenn-media.s3.us-east-1.amazonaws.com/abuser-photos/1742037533128-0-download.jpeg",
    ],
  },
  status: "awaiting review",
  _id: "67d5621d2b5fbb246d9b16c4",
  createdAt: "2025-03-15T11:18:53.310Z",
  updatedAt: "2025-03-15T11:18:53.310Z",
  __v: 0,
};

export const reportStatusStyles: Record<ReportStatusType, string> = {
  submitted: "bg-success text-[#025B27]",
  "awaiting review": "bg-success text-[#025B27]",
  "under review": "bg-info text-[#083950]",
  reviewed: "bg-danger text-[#800C22]",
};

export const csvHeaderOptions = [
  { label: "ID", key: "ID" },
  { label: "Report ID", key: "reportId" },
  { label: "Case Name", key: "caseName" },
  { label: "Case Type", key: "caseType" },
  { label: "Incident Date", key: "incidentDate" },
  { label: "Incident Location", key: "incidentLocation" },
  { label: "Online Incident Location", key: "onlineIncidentLocation" },
  { label: "City", key: "city" },
  { label: "County", key: "county" },
  { label: "State", key: "state" },
  { label: "Incident Narration", key: "incidentNarration" },
  { label: "Incident Photo Evidence", key: "incidentPhotoEvidence" },
  { label: "Incident Voice Narration", key: "incidentVoiceNarration" },
  { label: "Reporter Age", key: "reporterAge" },
  { label: "Reporter Email", key: "reporterEmail" },
  { label: "Reporter Gender", key: "reporterGender" },
  { label: "Reporter Phone", key: "reporterPhone" },
  { label: "Reporter Role", key: "reporterRole" },
  { label: "Reporter Socials", key: "reporterSocials" },
  { label: "Has Abuser Info", key: "hasAbuserInfo" },
  { label: "Abuser Name", key: "abuserName" },
  { label: "Abuser Nickname", key: "abuserNickname" },
  { label: "Abuser Gender", key: "abuserGender" },
  { label: "Abuser Age", key: "abuserAge" },
  { label: "Abuser Physical Description", key: "abuserPhyDescription" },
  {
    label: "Has Abuser Vehicle Info",
    key: "hasAbuserVehicleInfo",
  },
  {
    label: "Has Special Authority",
    key: "hasSpecialAuthority",
  },
  {
    label: "Special Authority Position",
    key: "specialAuthorityPosition",
  },
  { label: "Occupation", key: "occupation" },
  { label: "Abuser Physical Description", key: "abuserPhyDescription" },
  {
    label: "Relation To Victim",
    key: "relationToVictim",
  },
  { label: "Abuser Vehicle Info", key: "abuserVehicleInfo" },
  { label: "Abuser Socials", key: "abuserSocials" },

  { label: "Need An Attorney", key: "needAttorney" },
  { label: "Need Counseling", key: "needCounseling" },
  { label: "Need Private Investigator", key: "needPrivateInvestigator" },

  { label: "Status", key: "status" },
  { label: "Created At", key: "createdAt" },
];

export const filterOptions = [
  { label: "Event Concern", value: "eventConcern" },
  { label: "Location", value: "location" },
  { label: "Date", value: "date" },
  { label: "Reporter Details", value: "reporterDetails" },
  { label: "Abuser Info", value: "abuserInfo" },
  { label: "Support Services", value: "supportServices" },
  { label: "Status", value: "status" },
];

export const defaultFilterCriteria: FilterCriteria = {
  caseType: undefined,
  subCaseType: undefined,
  date: {
    mode: "incidentDate",
    type: "all",
    startDate: undefined,
    endDate: undefined,
  },
  location: undefined,
  detailedIncidentLocation: { state: "", city: "", county: "" },
  reporterDetails: {
    role: undefined,
    gender: undefined,
    age: undefined,
    phone: undefined,
    email: undefined,
    ethnicity: undefined,
  },
  abuserInfo: {
    name: undefined,
    alias: undefined,
    gender: undefined,
    refAge: undefined,
    relation: undefined,
    occupation: undefined,
    ethnicity: undefined,
    hasSpecialAuthority: false,
    authorityPosition: undefined,
    phyDescription: undefined,
    hasAbuserVehicleInfo: true,
    vehicleInfo: {
      brand: undefined,
      model: undefined,
      carColor: undefined,
      licensePlate: undefined,
    },
  },
  supportServices: {
    NeedAnAttorney: null,
    NeedCounseling: null,
    NeedPrivateInvestigator: null,
  },
  reportStatus: undefined,
};

export const formattedVehicleInfo = (
  vehicleInfo?: AbuserVehicleInfo | null
) => {
  if (!vehicleInfo) return "";

  return `${vehicleInfo.carColor} ${vehicleInfo.model} ${
    vehicleInfo.brand
  }, License plate number: ${vehicleInfo.licensePlate || "N/A"}`;
};

export const socialsJointText = (socials: Socials | undefined) => {
  const noSocials =
    !socials || Object.values(socials).every((value) => !value || value === "");

  if (noSocials) return "Not Available";

  return (
    Object.entries(socials || {})
      .filter(([, handle]) => handle) // Ensure handle exists
      .map(([social, handle]) => `${social}: ${handle}`)
      .join(", ") || "Not Available"
  );
};
